// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')
// Sibling imports
const RecReasonRecord = require('./rec-reason')

class FeedItemMetaRecord extends Immutable.Record({
  recId: null,
  recReason: null,
  recPosition: null
}) {
  // No methods
}

FeedItemMetaRecord.reviver = keyedReviver(FeedItemMetaRecord, {
  recReason: RecReasonRecord.reviver
})

FeedItemMetaRecord.propTypes = {
  recId: PropTypes.string,
  recPosition: PropTypes.number,
  recReason: PropTypes.shape(RecReasonRecord.propTypes)
}

module.exports = FeedItemMetaRecord
